// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"wap_privacyPolicy__ReNnw","privacyPolicyContent":"wap_privacyPolicyContent__nZ3Ez"};